import React from "react";
import "./ExploreOurProducts.scss";
import PrevArrow from "~/components/slickSlider/PrevArrow";
import NextArrow from "~/components/slickSlider/NextArrow";
import Slider from "react-slick";
import Item from "~/components/miniComponent/item/Item";

function ExploreOurProducts() {
  // Slick Slider
  const exploreOurProductsSlider = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2500,
    arrows: true,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <div className="my-5">
      <div className="sub-title-heading">Sản phẩm của chúng tôi</div>
      <h3 className="title-heading">
        <a href="/">Khám phá sản phẩm</a>
      </h3>
      <Slider
        className="slider-explore-our-products"
        {...exploreOurProductsSlider}
      >
        <Item />
        <Item />
        <Item />
        <Item />
        <Item />
        <Item />
        <Item />
        <Item />
        <Item />
        <Item />
      </Slider>
    </div>
  );
}

export default ExploreOurProducts;
